module.exports = __webpack_public_path__ + "static/img/17063B_1_2_C_20220628_LC.abd9009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17063B_1_2_C_20220628_LC.png
// module id = gpN+
// module chunks = 0